module.exports = __webpack_public_path__ + "media/images/icon-validated-prototyles-aa92a8bf28e14285356b616d3ecfe81f.svg";